import React, { FC } from 'react';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { Typography } from '@mui/material';
import { useStyles } from './EvaluationClosedMessage.styles';
import ClockIcon from '@assets/img/new-year-time.png';

interface Props {
  evaluationDate: string;
}

export const EvaluationClosedMessage: FC<Props> = ({ evaluationDate }) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <img src={ClockIcon} alt="Clock" className={styles.icon} />
      <div className={styles.textContainer}>
        <Typography className={styles.title}>Evaluation meeting was closed</Typography>
        <Typography className={styles.title}>on {format(parseISO(evaluationDate), 'MMMM d, yyyy')}</Typography>
        <Typography className={styles.message}>See you next time!</Typography>
      </div>
    </div>
  );
};
